import ActionType from './ActionType'
import { Auth } from 'utils/Auth'
import { Auth as DefaultAuth } from 'aws-amplify'

// export const setAuthState = (payload) => (dispatch) =>
//   dispatch({
//     type: ActionType.Auth.SET_AUTH_STATE,
//     payload,
//   })

// export const setUser = (payload) => (dispatch) =>
//   dispatch({
//     type: ActionType.Auth.SET_USER,
//     payload,
//   })

export const closeError = () => dispatch =>
  dispatch({
    type: ActionType.Auth.CLOSE_ERROR,
  })

export const userSignOut = () => dispatch => {
  dispatch({
    type: ActionType.Auth.SIGNOUT_REQUEST,
  })

  return DefaultAuth.signOut()
    .then(data => {
      dispatch({
        type: ActionType.Auth.SIGNOUT_SUCCESS,
        payload: data,
      })
      return window.location.reload()
    })
    .catch(err =>
      dispatch({
        type: ActionType.Auth.SIGNOUT_FAILURE,
        payload: err,
      }),
    )
}

const urlParams = new URLSearchParams(window.location.search)
const jwtToken = urlParams.get('jwtToken')

export const refreshToken = () => (dispatch, getState) => {
  // console.log('calls refreshToken')
  return new Promise((resolve, reject) => {
    dispatch({
      type: ActionType.Auth.REFRESH_TOKEN_REQUEST,
    })

    return DefaultAuth.currentSession()
      .then(currentSession => {
        DefaultAuth.currentAuthenticatedUser()
          .then(cognitoUser => {
            cognitoUser.refreshSession(
              currentSession.refreshToken,
              (err, session) => {
                if (session) {
                  if (!jwtToken) {
                    const devOrProd =
                      window?.location?.href?.slice?.(0, 29) ===
                      'https://console.vastreach.com'
                        ? 'Prod'
                        : 'Dev'

                    const vastReachProfilesByUsernameString =
                      window?.localStorage?.getItem(
                        `vastReachProfilesByUsername${devOrProd}`,
                      )

                    if (vastReachProfilesByUsernameString) {
                      const vastReachProfilesByUsername = JSON.parse(
                        vastReachProfilesByUsernameString,
                      )

                      vastReachProfilesByUsername[
                        session?.idToken?.payload?.['cognito:username']
                      ] = {
                        username:
                          session?.idToken?.payload?.['cognito:username'],
                        accessToken: session?.accessToken?.jwtToken,
                        refreshToken: session?.refreshToken?.token,
                        idToken: session?.idToken?.jwtToken,
                        company_logo_url_color:
                          getState()?.data?.['account/preference']?.preferences
                            ?.company_logo_url_color,
                        business_name: getState()?.data?.account?.business_name,
                      }

                      if (window?.localStorage?.setItem) {
                        window.localStorage.setItem(
                          `vastReachProfilesByUsername${devOrProd}`,
                          JSON.stringify(vastReachProfilesByUsername),
                        )
                      }
                    }
                  }

                  dispatch({
                    type: ActionType.Auth.REFRESH_TOKEN_SUCCESS,
                    payload: session,
                  })
                }
                resolve(session)
              },
            )
          })
          .catch(err => {
            dispatch({
              type: ActionType.Auth.REFRESH_TOKEN_FAILURE,
              payload: err,
            })
            reject(err)
          })
      })
      .catch(err => {
        dispatch({
          type: ActionType.Auth.REFRESH_TOKEN_FAILURE,
          payload: err,
        })
        reject(err)
      })
  })
}

export const currentCredentials = () => dispatch =>
  new Promise((resolve, reject) => {
    dispatch({
      type: ActionType.Auth.CURRENT_CREDENTIALS_REQUEST,
    })

    return Auth.currentCredentials()
      .then(payload => {
        if (payload && payload.notOk) {
          dispatch({
            type: ActionType.Auth.CURRENT_CREDENTIALS_FAILURE,
            payload,
            notOk: true,
          })
          reject(payload)
          return
        }

        dispatch({
          type: ActionType.Auth.CURRENT_CREDENTIALS_SUCCESS,
          payload,
        })
        resolve(payload)
      })
      .catch(err => {
        dispatch({
          type: ActionType.Auth.CURRENT_CREDENTIALS_FAILURE,
          payload: err,
        })
        reject(err)
      })
  })

export const currentSession = () => dispatch =>
  new Promise((resolve, reject) => {
    dispatch({
      type: ActionType.Auth.CURRENT_SESSION_REQUEST,
    })

    return Auth.currentSession()
      .then(payload => {
        if (payload && payload.notOk) {
          dispatch({
            type: ActionType.Auth.CURRENT_SESSION_FAILURE,
            payload,
          })
          reject(payload)
          return
        }

        dispatch({
          type: ActionType.Auth.CURRENT_SESSION_SUCCESS,
          payload,
        })
        resolve(payload)
      })
      .catch(err => {
        dispatch({
          type: ActionType.Auth.CURRENT_SESSION_FAILURE,
          payload: err,
        })
        reject(err)
      })
  })
